import { Card, Col, Container, Row } from "react-bootstrap";
import { useLoaderData, useRevalidator } from "react-router-dom";
import { OrderAdjustReq, OrderDetails } from "./Data/ApiTypes";
import { PageTitle } from "./Controls/PageTitle";
import { cents, showMoney, toCents } from "./Data/Money";
import { showOrderBalanceType, showOrderType } from "./Data/Finance";
import { showInstantDateTime } from "./Data/Date";
import { equal } from "dinero.js";
import { Hyperlink } from "./Controls/Hyperlink";
import { MediumPage } from "./Controls/MediumPage";
import { OrderPaidBadge } from "./Controls/OrderPaidBadge";
import { OrderAdjustForm, OrderAdjustModal } from "./FacilityParkerOrderDetailsPageOrderAdjustModal";
import { useState } from "react";
import { Api } from "./Data/Api";
import { useParamIds } from "./Data/Common";
import { PageBar } from "./Controls/PageBar";
import { InfoIcon, InfoIconSmall } from "./Controls/InfoIcon";

export function FacilityParkerOrderDetailsPage() {
    const { facilityId, parkerId } = useParamIds();
    const { revalidate } = useRevalidator();
    const [showAdjust, setShowAdjust] = useState( false );
    const orderDetails = useLoaderData() as OrderDetails;
    const order        = orderDetails.order;
    const facility     = orderDetails.order.facility;
    const chgs         = orderDetails.balanceChanges;
    const last         = chgs.sort( (a, b) => a.orderBalanceId - b.orderBalanceId ).toReversed()[0];
    const bal          = last.balance;

    let status = "Open";
    if( equal( bal, cents( 0 ) ) ) {
        status = "Paid"
    }

    async function saveAdjustment( adjustData: OrderAdjustForm ) {
        const req: OrderAdjustReq = {
            orderId: order.orderId,
            currentTotalDebt: order.balance.totalDebt,
            newTotalDebt: cents( adjustData.newTotalDebt ),
            reason: adjustData.reason,
        };
        const res = await Api.orderAdjust( facilityId, parkerId, req );
        if( res.isOk ) {
            revalidate(); //reload this page
            return;
        }
        //else
        alert( res.error );
    }

    return <MediumPage>
        <OrderAdjustModal
            currentTotalDebt={order.balance.totalDebt}
            show={showAdjust}
            setShow={setShowAdjust}
            onSave={saveAdjustment} />
        <Row>
            <Col>
                <PageBar title={`Order #${order.orderId}`}>
                    {/* <ToolButton onClick={ () => setShowAdjust( true )}>
                        <PlusSlashMinus className="fs-6" /> Adjust Debt
                    </ToolButton> */}
                </PageBar>
                <Container className="g-0">
                    <Row>
                        <Col className="fs-6">
                            <table className="table w-auto" cellPadding={4}>
                                <tr>
                                    <td>{showOrderType( order.type )}</td>
                                    <td>{order.summary}</td>
                                </tr>
                                <tr>
                                    <td>Order Status</td>
                                    <td className="text-end">
                                        <OrderPaidBadge balance={order.balance.balance} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Order Price</td>
                                    <td className="text-end">{showMoney( last.totalDebt )}</td>
                                </tr>
                                {equal( order.price, last.totalDebt ) !== true && <tr>
                                    <td>Price (Late Fees)</td>
                                    <td className="text-end">{showMoney( last.totalDebt )}</td>
                                </tr>}
                                <tr>
                                    <td>Total Paid</td>
                                    <td className="text-end">{showMoney( last.totalPaid )}</td>
                                </tr>
                                <tr className="fw-bold">
                                    <td>Amount Due</td>
                                    <td className="text-end">{showMoney( last.balance )}</td>
                                </tr>
                            </table>
                        </Col>
                    </Row>
                </Container>
                <PageTitle>
                    Timeline
                </PageTitle>
                {chgs.map( chg => {
                    return <Card key={chg.orderId} className="my-2">
                        {/* <Card.Header className="text-start fw-bold" style={{ display: "grid", gridTemplateColumns: "1fr 1fr"}}>
                            <div>{showOrderBalanceType( chg.type )} </div>
                            <div className="text-end">
                                {showInstantDateTime( chg.createdWhen, facility.timeZone ) }
                            </div>
                        </Card.Header> */}
                        <Card.Body style={{ display: "grid", gridTemplateAreas: `'a b c' 'd e f'` }}>
                            <div className="grid-area-a d-flex-align-center">
                                {!equal( cents( 0 ), chg.paid ) && <>
                                    <Hyperlink to={`/facility/${facility.facilityId}/parker/${order.parkerId}/payment/${chg.paymentId}`}>
                                        Payment
                                    </Hyperlink> of {showMoney( chg.paid )} Applied
                                </>}
                                {toCents( chg.debt ) > 0 && <>Amount Due Increased by {showMoney( chg.debt )}</>}
                                {toCents( chg.debt ) < 0 && <>Amount Due Decreased by {showMoney( cents( Math.abs( toCents( chg.debt ) ) ) )}</>}
                                &nbsp;
                                {chg.reason?.length !== 0 &&<InfoIconSmall>
                                    {chg.reason}
                                </InfoIconSmall>}
                            </div>
                            <div className="grid-area-c" style={{ justifySelf: "end" }}>
                                <div className="fw-bold">
                                    {showMoney( chg.balance )}
                                </div>
                                {/* <div style={{ fontSize: "0.75em", position: "relative", top: "-5%", left: "0.05em" }} className="text-end">
                                    {toCents( chg.balance ) > 0 && <>Outstanding</>}
                                </div> */}
                            </div>
                        </Card.Body>
                    </Card>;
                } )}
            </Col>
        </Row>
    </MediumPage>;
}